interface ActiveClickIntent {
  ctrlKey: boolean
  metaKey: boolean
}

let activeClickIntent: ActiveClickIntent | null = null
let activeClickSequence = 0

export function rememberRouteClickIntent(event: MouseEvent) {
  const sequence = ++activeClickSequence
  activeClickIntent = {
    ctrlKey: event.ctrlKey,
    metaKey: event.metaKey,
  }

  queueMicrotask(() => {
    if (activeClickSequence === sequence) activeClickIntent = null
  })
}

export function shouldOpenRouteInNewTab() {
  return activeClickIntent?.ctrlKey === true || activeClickIntent?.metaKey === true
}

export function openRouteInNewTab(href: string, state: unknown) {
  if (state === undefined) {
    const openedWindow = window.open(href, '_blank')
    if (openedWindow) openedWindow.opener = null
    return
  }

  // A new document normally loses React Router's history state. Seed the blank tab's
  // same-origin history entry before loading so state-backed destinations (for example,
  // opening a specific record or settings panel) land on the exact requested surface.
  const openedWindow = window.open('', '_blank')
  if (!openedWindow) return

  openedWindow.opener = null
  try {
    openedWindow.history.replaceState({ usr: state, key: crypto.randomUUID(), idx: 0 }, '', href)
    openedWindow.location.reload()
  } catch {
    openedWindow.location.replace(href)
  }
}
